import { Column } from "@tento-ui/component-builtin";
import { Toast } from "@tento-ui/components/toast/toast";
import { Storybook } from "@tento-ui/ui/storybook";
import { DateTime, Duration, Utc } from "@tento-chrono";
import { PendingEventSubtitle } from "./pending-event-subtitle";

export class PendingEventSubtitleStoryBook extends Storybook.Default {
  title(): string {
    return "Pending Event Subtitle";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Default",
        render: () => {
          const start = Utc.now().nearest(Duration.Time.MIN15);
          const time = new DateTime.Range(start, start.add({ hrs: 1 }));

          const $subtitle = PendingEventSubtitle.makeWith({
            time,
            onGoing: () => Toast.info("Going clicked"),
            onNotGoing: () => Toast.info("Not going clicked"),
          });

          const $container = Column.make();
          $container.assignStyles({ width: "300px", padding: "16px" });
          $container.appendChild($subtitle);
          return $container;
        },
      },
      {
        title: "Going Highlighted",
        render: () => {
          const start = Utc.now().nearest(Duration.Time.MIN15);
          const time = new DateTime.Range(start, start.add({ hrs: 1 }));

          const $subtitle = PendingEventSubtitle.makeWith({
            time,
            status: "accepted",
            onGoing: () => Toast.info("Going clicked"),
            onNotGoing: () => Toast.info("Not going clicked"),
          });

          const $container = Column.make();
          $container.assignStyles({ width: "300px", padding: "16px" });
          $container.appendChild($subtitle);
          return $container;
        },
      },
      {
        title: "Not Going Highlighted",
        render: () => {
          const start = Utc.now().nearest(Duration.Time.MIN15);
          const time = new DateTime.Range(start, start.add({ hrs: 1 }));

          const $subtitle = PendingEventSubtitle.makeWith({
            time,
            status: "declined",
            onGoing: () => Toast.info("Going clicked"),
            onNotGoing: () => Toast.info("Not going clicked"),
          });

          const $container = Column.make();
          $container.assignStyles({ width: "300px", padding: "16px" });
          $container.appendChild($subtitle);
          return $container;
        },
      },
    ];
  }
}
